import { ErrorBase } from '../model/ErrorBase';
import { Error, isError } from 'fl-foundation';
import { QPError } from '../model/QPError';

export class ErrorFactory {
  static isPlatformError(error: Error | any): boolean {
    return isError(error);
  }

  static get(error: Error | any, errorType?: any): ErrorBase {
    let result: ErrorBase;

    if (isError(error)) {
      const platformError: Error = error as unknown as Error;
      result = new QPError(platformError.errorMessage, platformError, errorType);
    } else {
      result = new ErrorBase(error);
    }

    return result;
  }
}
